import BackButton from 'components/backButton'
import { PurchaseTimerAddForm } from 'components/purchaseTimer'
import { useSafeBack } from 'hooks'
import { Helmet } from 'react-helmet'
import { PAGE_PURCHASE_TIMER } from 'utils/constants'

const PurchaseTimerAddPage = () => {
  const handleBack = useSafeBack(PAGE_PURCHASE_TIMER.path)

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Add Purchase Timer</title>
      </Helmet>

      <BackButton handleBack={handleBack} />

      <h1 className="py-3 text-lg font-bold">Add Purchase Timer</h1>

      <PurchaseTimerAddForm />
    </>
  )
}

export default PurchaseTimerAddPage
